<template>
  <div>

          






    <b-modal
      id="opcoes-institucionais"
      content-class="bg-dark-mx3--"
      fullscreen
      hide-header
      hide-footer
    >
      <b-row>
        <b-col class="d-flex mb-4 cursor-pointer justify-content-end" @click="$bvModal.hide('opcoes-institucionais')">
          <span class="text-muted text-right"
            ><b-icon-chevron-left></b-icon-chevron-left> Fechar</span
          >
          <div class=""></div>
        </b-col>
      </b-row>
      <div class="bg-dark-mx3--">
        <li class="dropdown categorias-container-2 bg-dark-mx3--">
          <!-- <a href="#">
                      <span class="text-muted">Categorias</span>
                    </a> -->

          <ul class="category-list m-1">
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/seguranca')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Segurança
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/contato')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Contato
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/garantia')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Garantia
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/sobre')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Sobre
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/projetos-redes')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Projetos de Redes
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/termos')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Termos
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/privacidade')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Privacidade
              </a>
            </li>
            <li
              style="border-radius: 14px; margin-bottom: 5px"
              class="cursor-pointer"
              @click="$util.redirectTo('/cookies')"
            >
              <a class="text-white" style="padding: 10px 15px; display: block">
                Cookies
              </a>
            </li>
          </ul>
        </li>
      </div>
      <!-- <b-row>
        <b-col>
          <div
            class="filter-group mb-4"
            v-if="subcategoriaSelecionada && filtrosList.length"
          >
            <h5 class="text-center filter-title mb-2 filtro-text-color texto-claro-modal">
              Filtro
            </h5>
            <ul class="list-unstyled category-list product-filter-list">
              <li
                :class="{
                  'is-active': filtroProdutoSelecionado === null,
                }"
                @click="filterByFiltroProduto(null)"
                class="filter-item cursor-pointer"
              >
                <span class="category-name filtro-text-color texto-claro-modal">Todos</span>
              </li>
              <li
                v-for="(filtro, k) in filtrosList"
                :key="'filtro-' + k"
                :class="{
                  'is-active': filtroProdutoSelecionado === filtro.id,
                }"
                @click="filterByFiltroProduto(filtro)"
                class="filter-item cursor-pointer"
              >
                <span class="category-name filtro-text-color texto-claro-modal">{{
                  filtro.nome
                }}</span>
              </li>
            </ul>
          </div>

          <div
            class="filter-group mb-4"
            v-if="categoriaSelecionada && subcategorias.length"
          >
            <h5 class="text-center filter-title mb-2 filtro-text-color texto-claro-modal">
              Sub Categorias
            </h5>
            <ul class="list-unstyled category-list subcategory-list">
              <li
                :class="{ 'is-active': subcategoriaSelecionada === null }"
                @click="filterBySubcategoria(null)"
                class="filter-item cursor-pointer"
              >
                <span class="category-name filtro-text-color texto-claro-modal">Todas</span>
              </li>
              <li
                v-for="(subcat, j) in subcategorias"
                :key="'sub-' + j"
                :class="{
                  'is-active': subcategoriaSelecionada === subcat.id,
                }"
                @click="filterBySubcategoria(subcat)"
                class="filter-item cursor-pointer"
              >
                <span class="category-name filtro-text-color texto-claro-modal">{{
                  subcat.nome
                }}</span>
              </li>
            </ul>
          </div>

          <div class="filter-group mb-4">
            <h5 class="text-center filter-title mb-2 filtro-text-color texto-claro-modal">
              Categorias
            </h5>
            <ul class="list-unstyled category-list">
              <li
                v-for="(categoria, i) in categorias"
                :key="'cat-' + i"
                :class="{
                  'is-active': categoriaSelecionada === categoria.id,
                }"
                @click="filterByCategoria(categoria)"
                class="filter-item cursor-pointer"
              >
                <span class="category-name filtro-text-color texto-claro-modal">{{
                  categoria.nome
                }}</span>
                <b-badge
                  v-if="false"
                  pill
                  :class="
                    categoriaSelecionada === categoria.id
                      ? 'bg-light filtro-text-color'
                      : 'bg-secondary text-light'
                  "
                >
                  {{ categoria.qtd }}
                </b-badge>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row> -->
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productsAll: [],
      products: [],
      categorias: [],
      categoriaSelecionada: null,
      subcategorias: [],
      subcategoriaSelecionada: null,
      filtrosList: [],
      filtroProdutoSelecionado: null,
      tagFilter: "",
      orderBy: "estoque",
      filterByName: this.$route.query.q,

      // **VARIÁVEIS DE PAGINAÇÃO**
      currentPage: 1, // Página atual
      perPage: 10, // Itens por página
      totalRows: 0, // Total de produtos filtrados
      firstload: true,
    };
  },
  // CORREÇÃO: Inicializar todos os filtros da URL e carregar dados dependentes
  async mounted() {
    console.log("pegando categorias", this.$api);
    this.$api.getCategorias().then((res) => {
      this.categorias = res.data;
    });
    // 1. Inicializa categoria, subcategoria e filtroproduto da URL
    this.categoriaSelecionada = this.$route?.query?.categoria
      ? parseInt(this.$route.query.categoria)
      : null;

    this.subcategoriaSelecionada = this.$route?.query?.subcategoria
      ? parseInt(this.$route.query.subcategoria)
      : null;

    this.filtroProdutoSelecionado = this.$route?.query?.filtroproduto
      ? parseInt(this.$route.query.filtroproduto)
      : null;

    // 2. Carrega subcategorias se a categoria estiver selecionada (usando await)
    if (this.categoriaSelecionada) {
      await this.loadSubcategorias();
    }

    // 3. Carrega filtros de produto se a subcategoria estiver selecionada na URL
    if (this.subcategoriaSelecionada) {
      this.loadFiltrosList();
    }

    // 4. Carrega produtos com os filtros da URL
    this.loadProdutos();
  },
  methods: {
    loadFiltrosList() {
      this.filtrosList = [];
      // Não resetamos filtroProdutoSelecionado aqui, pois ele pode ter vindo da URL

      if (this.subcategoriaSelecionada) {
        this.$api
          .get(`filtroprodutos/?subcategoria=${this.subcategoriaSelecionada}`)
          .then((res) => {
            this.filtrosList = res.data;
          })
          .catch((error) => {
            console.error(
              "Erro ao carregar lista de filtros de produto:",
              error
            );
          });
      }
    },

    loadProdutos(clicked = false) {
      this.$bvModal.hide("categorias-filtro-global");

      setTimeout(() => {
        let params = {};

        if (this.filterByName) {
          params.nome = this.filterByName;
        }

        if (this.categoriaSelecionada) {
          params.categoria = this.categoriaSelecionada;
        }

        if (this.subcategoriaSelecionada) {
          params.subcategoria = this.subcategoriaSelecionada;
        }

        if (this.filtroProdutoSelecionado) {
          params.filtroproduto = this.filtroProdutoSelecionado;
        }

        if (this.tagFilter) {
          params.tag = this.tagFilter;
        }

        // **CHAMADA PRINCIPAL (PRODUTOS FILTRADOS)**
        this.$api.getProdutos(params).then((res) => {
          let allFilteredProducts = res.data; // Produtos filtrados pela API

          // 1. Aplica a ordenação
          if (this.orderBy) {
            allFilteredProducts = allFilteredProducts.sort((a, b) => {
              if (this.orderBy === "estoque") {
                return b.estoque - a.estoque;
              }
              if (this.orderBy === "nome") {
                return a.nome < b.nome ? -1 : 1;
              }
              if (this.orderBy === "valor") {
                return a.preco - b.preco;
              }
            });
          }

          // 2. Define o total de linhas **E RESETA A PÁGINA SE NECESSÁRIO**
          this.totalRows = allFilteredProducts.length;

          // Garante que não estamos em uma página inválida
          const maxPage = Math.ceil(this.totalRows / this.perPage);
          if (this.currentPage > maxPage && maxPage > 0) {
            this.currentPage = maxPage;
          } else if (this.totalRows > 0 && this.currentPage === 0) {
            this.currentPage = 1; // Para evitar o erro de página 0
          } else if (this.totalRows === 0) {
            this.currentPage = 1;
          }

          // 3. Aplica a paginação no frontend (slice)
          const startIndex = (this.currentPage - 1) * this.perPage;
          const endIndex = startIndex + this.perPage;
          this.products = allFilteredProducts.slice(startIndex, endIndex);

          // **Atualização do histórico/URL para refletir os filtros**
          const query = {};
          if (params.nome) query.q = params.nome;
          if (params.categoria) query.categoria = params.categoria;
          if (params.subcategoria) query.subcategoria = params.subcategoria;
          if (params.filtroproduto) query.filtroproduto = params.filtroproduto;

          if (
            Object.keys(query).length > 0 ||
            Object.keys(this.$route.query).length > 0
          ) {
            this.$router.replace({ query }).catch(() => {});
          }

          // **CÁLCULO DE QUANTIDADE DE PRODUTOS POR CATEGORIA (Mantido)**
          this.$api.getProdutos().then((response) => {
            this.productsAll = response.data;

            if (
              localStorage.getItem("filterCategoria") &&
              !this.categoriaSelecionada &&
              !this.subcategoriaSelecionada
            ) {
              this.categoriaSelecionada = Number(
                JSON.parse(localStorage.getItem("filterCategoria")).id
              );
              localStorage.removeItem("filterCategoria");
              this.$forceUpdate();
              return;
            }

            this.$api.getCategorias().then((res) => {
              this.categorias = res.data;
              if (this.productsAll.length) {
                this.categorias = this.categorias
                  .map((c) => {
                    return {
                      ...c,
                      qtd: this.productsAll.filter((p) => p.categoria == c.id)
                        .length,
                    };
                  })
                  .sort((a, b) => (a.qtd < b.qtd ? 1 : -1));
              }
            });
          });

          // BLOCO DE HARD RELOAD (Mantido conforme solicitado)
          if (clicked === true) {
            // Constrói a query de forma dinâmica e limpa, removendo valores nulos/vazios
            const finalQuery = Object.keys(params)
              .filter(
                (key) =>
                  params[key] !== null &&
                  params[key] !== undefined &&
                  params[key] !== ""
              )
              .map((key) => `${key}=${params[key]}`)
              .join("&");

            this.$util.redirectTo(`/products?${finalQuery}`, "_self");
          }
        });
      }, 500);
    },

    // TORNA ASSÍNCRONA para poder usar `await` no `mounted`
    async loadSubcategorias() {
      this.subcategorias = [];

      if (this.categoriaSelecionada) {
        try {
          const res = await this.$api.get(
            "subcategorias/?categoria=" + this.categoriaSelecionada
          );
          this.subcategorias = res.data;
        } catch (error) {
          console.error("Erro ao carregar subcategorias:", error);
        }
      }
    },

    filterByCategoria(categoria) {
      if (this.categoriaSelecionada === categoria.id) {
        // Deselecionar categoria
        this.categoriaSelecionada = null;
        this.subcategoriaSelecionada = null;
        this.subcategorias = [];
        this.filtroProdutoSelecionado = null;
        this.filtrosList = [];
      } else {
        // Selecionar nova categoria
        this.categoriaSelecionada = categoria.id;
        this.subcategoriaSelecionada = null;
        this.filtroProdutoSelecionado = null;
        this.loadSubcategorias();
        this.filtrosList = [];
      }
      this.currentPage = 1; // **RESET DA PÁGINA**
      this.loadProdutos(true);
      // this.$util.scrollTop();
    },

    filterBySubcategoria(subcategoria) {
      this.subcategoriaSelecionada = subcategoria ? subcategoria.id : null;
      this.filtroProdutoSelecionado = null;
      this.loadFiltrosList();
      this.currentPage = 1; // **RESET DA PÁGINA**
      this.loadProdutos(true);
      // this.$util.scrollTop();
    },

    filterByFiltroProduto(filtro) {
      this.filtroProdutoSelecionado = filtro ? filtro.id : null;
      this.currentPage = 1; // **RESET DA PÁGINA**
      this.loadProdutos(true);
      // this.$util.scrollTop();
    },
  },
  watch: {
    tagFilter() {
      this.currentPage = 1; // **RESET DA PÁGINA**
      this.loadProdutos();
    },
    // Watch para ordenação, que já chama loadProdutos no @change do template, mas mantido para consistência.
    orderBy() {
      this.currentPage = 1; // **RESET DA PÁGINA**
      // loadProdutos é chamado via @change no template
    },
    // Removidos os watchers de categoriaSelecionada e subcategoriaSelecionada
    // pois o hard reload agora lida com o estado.
  },
  computed: {
    tags() {
      let tags = [];

      for (const produto of this.productsAll) {
        if (produto.tags) {
          tags = [...tags, ...produto.tags.split(",")];
        }
      }

      return Array.from(new Set(tags));
    },
  },
};
</script>

<style scoped>
.texto-claro-modal {
  color: white !important;
}

/* Estilos mantidos, apenas para contexto */
.cursor-pointer {
  cursor: pointer;
}

/* --- Estilos para os Filtros Laterais --- */

.filter-group {
  padding: 10px;
  border-radius: 8px;
}

.filter-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #343a40;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.category-list {
  padding-left: 0;
}

.filter-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 3px;
  border-radius: 5px;
  transition: background-color 0.2s, color 0.2s;
  font-size: 0.95rem;
  color: #555;
}

.filter-item:hover:not(.is-active) {
  background-color: #f0f0f020;
  color: #333;
}

.filter-item.is-active {
  background-color: var(--primary);
  color: white;
  font-weight: bold;
}

.subcategory-list .filter-item,
.product-filter-list .filter-item {
  /* Estilo similar para o novo filtro */
  padding-left: 20px;
  font-size: 0.9rem;
}

/* --- Esconder/Mostrar elementos para desktop e mobile --- */
@media (max-width: 767.98px) {
  .hide-on-mobile {
    display: none !important;
  }
  .show-on-mobile {
    display: block !important;
  }
}

@media (min-width: 768px) {
  .show-on-mobile {
    display: none !important;
  }
}

#products-container-custom {
  max-width: 84%;
}
#produto-item- {
  width: 30%;
  max-width: 300px;
  min-width: 210px;
}

@media (max-width: 768px) {
  #products-container-custom {
    width: 100% !important;
    max-width: 100% !important;
  }
  #produto-item- {
    width: 50%;
    max-width: unset;
    min-width: unset;
    scale: 0.9;
    padding: 0.1px !important;
  }
  #produto-item- > div {
    margin: 1px !important;
  }
  #produto-item- > button > small {
    font-size: 5px !important;
  }
}
</style>



<style>
.header-action-btn {
  border-radius: 10px !important;
  width: 65px !important;
  height: 65px !important;
  text-align: center !important;
  border: 0.1px solid #ffffff10 !important;
}

.header-action-btn .badge {
  position: absolute;
  top: 2px;
  right: 2px;
  color: rgb(255, 255, 255);
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
  background: linear-gradient(135deg, rgb(0, 217, 255), rgb(10, 97, 201));
  border-radius: 10px;
  padding: 2px 6px;
}
.header-action-btn .badge:hover {
  color: var(--primary) !important;
}

.navmenu a {
  font-weight: 600 !important;
}

.navmenu a {
  font-weight: 600;
  color: #064089;
  transition: all 0.3s ease;
  position: relative;
}

/* .navmenu a:before {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--mx3-style-primary, #00d9ff);
  transform: scaleX(0);
  transition: transform 0.3s ease;
} */

.navmenu a.active:before,
.navmenu a:hover:before {
  transform: scaleX(1);
}

.navmenu a.active,
.navmenu a:hover {
  color: var(--mx3-style-primary, #00d9ff);
}
.navmenu .dropdown ul {
  background: var(--mx3-style-bg-card, #161b26) !important;
  border-radius: 15px !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.navmenu .dropdown ul li {
  margin-left: 5px;
  transition: all 1s ease;
}
.navmenu .dropdown ul li:hover {
  margin-left: 15px;
  transition: all 1s ease;
}
</style>

<style scoped lang="scss">
.categorias-container-2 {
  li {
    background-color: #afafaf !important;
  }
  .bg-white:not(.is-active) {
    background-color: white !important;
    border: solid #afafaf60 0.1px !important;
    color: black !important;
  }
  li:not(.is-active) {
    background: var(--mx3-style-bg-card, #161b26) !important;
    border: 0.5px solid #e5e5e520 !important;
    span {
      color: #e5e5e5 !important;
    }
  }
  li:not(.is-active):hover {
    background: var(--mx3-style-bg-card, #161b26) !important;
    border: 0.5px solid var(--mx3-style-primary, #00d9ff) !important;
    span {
      padding-left: 15px !important;
      text-shadow: 2px 2px 15px black !important;
      color: var(--mx3-style-primary, #00d9ff) !important;

      transition: all 0.3s ease;
    }
  }
  .is-active {
    background: transparent !important;
    border: 0.5px solid var(--mx3-style-primary, #00d9ff) !important;
    span {
      text-shadow: 5px 5px 15px black !important;
      color: var(--mx3-style-primary, #00d9ff) !important;
    }
  }
  /*.input-rounded-class*/
  .input-rounded-class {
    border-radius: 14px !important;
    border-top-right-radius: 14px !important;
    border-bottom-right-radius: 14px !important;
    background: var(--mx3-style-input-bg, #1b2230) !important;
    background-color: var(--mx3-style-input-bg, #1b2230) !important;
  }
  /*.input-rounded-class*/
  .button-rounded-class {
    border-top-left-radius: 14px !important;
    border-bottom-left-radius: 14px !important;
    border-radius: 14px !important;
    padding-right: 12px !important;
    height: 35px !important;
    scale: 0.9 !important;
    margin-top: 1px !important;
    right: 47px !important;
    position: relative !important;
  }
  /*.input-rounded-class*/
  .input-rounded-class2 {
    background: var(--mx3-style-input-bg, #1b2230) !important;
    background-color: var(--mx3-style-input-bg, #1b2230) !important;
    border-radius: 14px !important;
    /* border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-right:14px; */
  }

  /* Estilos mantidos, apenas para contexto */
  .cursor-pointer {
    cursor: pointer !important;
  }

  /* --- Estilos para os Filtros Laterais --- */

  .filter-group {
    padding: 10px !important;
    border-radius: 8px !important;
  }

  .filter-title {
    font-size: 1.1rem !important;
    font-weight: bold !important;
    color: #343a40 !important;
    border-bottom: 1px solid #eee !important;
    padding-bottom: 5px !important;
  }

  .category-list {
    padding-left: 0 !important;
  }

  .filter-item:hover {
    margin-left: 5px !important;
    transition: all 0.3s ease !important;
  }

  .filter-item {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 8px 10px !important;
    margin-bottom: 3px !important;
    border-radius: 5px !important;
    transition: background-color 0.2s, color 0.2s !important;
    font-size: 0.95rem !important;
    color: #555 !important;
  }

  .filter-item:hover:not(.is-active) {
    background-color: #f0f0f020 !important;
    color: #333 !important;
  }

  .filter-item.is-active {
    background-color: var(--primary) !important;
    color: white !important;
    font-weight: bold !important;
  }

  .subcategory-list .filter-item,
  .product-filter-list .filter-item {
    /* Estilo similar para o novo filtro */
    padding-left: 20px !important;
    font-size: 0.9rem !important;
  }

  /* --- Esconder/Mostrar elementos para desktop e mobile --- */
  @media (max-width: 767.98px) {
    .hide-on-mobile {
      display: none !important;
    }
    .show-on-mobile {
      display: block !important;
    }
  }

  @media (min-width: 768px) {
    .show-on-mobile {
      display: none !important;
    }
  }

  #products-container-custom {
    max-width: 80% !important;
  }
  #produto-item- {
    max-width: 300px !important;
    min-width: 280px !important;
  }

  @media (max-width: 768px) {
    #products-container-custom {
      width: 100% !important;
      max-width: 100% !important;
    }
    #produto-item- {
      width: 50% !important;
      max-width: unset !important;
      min-width: unset !important;
      scale: 0.9 !important;
      padding: 0.1px !important;
    }
    #produto-item- > div {
      margin: 1px !important;
    }
    #produto-item- > button > small {
      font-size: 5px !important;
    }
  }
  .filtro-text-color {
    color: black !important;
  }
  .category-name {
    padding: 10px !important;
    color: #ffffff50 !important;
  }
  .category-name:hover {
    padding: 10px !important;
  }
  .form-control {
    border: 1px solid #afafaf40 !important;
  }
  .form-control:focus {
    border: var(--mx3-style-primary, #00d9ff) solid 2px !important;
    box-shadow: unset !important;
  }
}
#header .main-header {
  border-bottom: transparent !important;
}

.button-header-action-- {
  width: 60px !important;
  height: 60px !important;
  transition: transform 0.2s ease !important;
}

.button-header-action--:hover {
  transform: translateY(-2px) !important;

  background: #111827 !important;
  border: var(--mx3-style-primary, #00d9ff) solid 0.5px !important;
}

.bg-dark-mx3-- {
  background: var(--mx3-style-bg-card, #161b26) !important;
  background-color: var(--mx3-style-bg-card, #161b26) !important;
}
</style>